var _style, _path, _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _rect2, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _rect3, _rect4, _path2, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _path3, _path4, _path5, _rect5, _rect6, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect7, _path26, _path27, _rect8, _rect9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPloKoonHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0pkh{fill:#838384;}\r\n\t.st1pkh{fill:#404D9C;}\r\n\t.st2pkh{fill:#424241;}\r\n\t.st3pkh{fill:#777777;}\r\n\t.st4pkh{fill:#2D2D2D;}\r\n\t.st5pkh{fill:#3F3F3F;}\r\n\t.st6pkh{fill:#D81718;}\r\n\t.st7pkh{fill:#AD1917;}\r\n\t.st8pkh{fill:#222323;}\r\n\t.st9pkh{fill:#747475;}\r\n\t.st10pkh{fill:#8B8B8E;}\r\n\t.st11pkh{fill:#AEAEAF;}\r\n\t.st12pkh{fill:#6E6F70;}\r\n\t.st13pkh{fill:#444444;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0pkh",
    d: "M4.6,197.9c3,1,7,1.9,11.9,2c6,0.2,11-0.9,14.3-2c1,0.1,1.9-0.7,1.9-1.8c0-1-0.9-1.9-1.9-1.8 c-8.8,0-17.6,0-26.5,0c-0.7,0.2-1.2,0.9-1.3,1.6C3,196.9,3.7,197.8,4.6,197.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.4,
    y: 173.1,
    className: "st1",
    width: 24.7,
    height: 21.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1pkh",
    cx: 17.7,
    cy: 184.6,
    rx: 17.2,
    ry: 2.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1pkh",
    cx: 17.6,
    cy: 188.7,
    rx: 17.2,
    ry: 2.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1pkh",
    cx: 17.9,
    cy: 192.5,
    rx: 17.2,
    ry: 2.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1pkh",
    cx: 17.6,
    cy: 180.5,
    rx: 17.2,
    ry: 2.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1pkh",
    cx: 17.9,
    cy: 175.8,
    rx: 17.2,
    ry: 2.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.8,
    y: 107.4,
    className: "st2pkh",
    width: 19.7,
    height: 47.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3pkh",
    cx: 17.6,
    cy: 110.2,
    rx: 13.7,
    ry: 2.4
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2pkh",
    cx: 17.6,
    cy: 114.9,
    rx: 13.7,
    ry: 2.4
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3pkh",
    cx: 17.5,
    cy: 119.7,
    rx: 13.7,
    ry: 2.4
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2pkh",
    cx: 17.8,
    cy: 124,
    rx: 13.7,
    ry: 2.4
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3pkh",
    cx: 17.8,
    cy: 128.7,
    rx: 13.7,
    ry: 2.4
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2pkh",
    cx: 17.5,
    cy: 133.4,
    rx: 13.7,
    ry: 2.4
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3pkh",
    cx: 17.8,
    cy: 137.9,
    rx: 13.7,
    ry: 2.4
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2pkh",
    cx: 17.5,
    cy: 142.6,
    rx: 13.7,
    ry: 2.4
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3pkh",
    cx: 17.8,
    cy: 147.1,
    rx: 12.1,
    ry: 2.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 97.2,
    className: "st0pkh",
    width: 24.7,
    height: 10.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 62.3,
    className: "st0pkh",
    width: 24.7,
    height: 36.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4pkh",
    d: "M5.3,97.5c3.5,0.3,7.3,0.5,11.3,0.5c4.8,0,9.3-0.2,13.4-0.5c0-0.4,0-0.8,0-1.2c-4.1,0.3-8.5,0.5-13.2,0.5 c-4.1,0-8-0.2-11.6-0.5C5.3,96.7,5.3,97.1,5.3,97.5z"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5pkh",
    cx: 29,
    cy: 91.4,
    rx: 3.5,
    ry: 4.6
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4pkh",
    cx: 29.8,
    cy: 91.5,
    rx: 2.6,
    ry: 3.7
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6pkh",
    cx: 29.4,
    cy: 71,
    rx: 4.3,
    ry: 4.9
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7pkh",
    cx: 30.4,
    cy: 71.2,
    rx: 3.2,
    ry: 3.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8pkh",
    d: "M4.6,60.1c-0.6,0-1-0.1-1.3-0.2c-2.1-0.7-2.7-3.3-2.8-3.6c-0.8-3-0.2-5.9,1.6-7.6c0.4-0.4,1.2-0.9,2.3-1.2 C4.8,49,5,50.5,5.3,52.1C5.1,54.7,4.9,57.4,4.6,60.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5pkh",
    d: "M5.6,60.1c-0.6,0-1-0.1-1.3-0.2c-2.1-0.7-2.7-3.3-2.8-3.6c-0.8-3-0.2-5.9,1.6-7.6c0.4-0.4,1.2-0.9,2.3-1.2 C5.8,49,6,50.5,6.3,52.1C6.1,54.7,5.9,57.4,5.6,60.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0pkh",
    d: "M31,60.2c-8.7,0-17.4,0-26.2,0c-0.2,0-0.4,0-0.5,0c0-4.4,0-8.7,0-13.1H31V60.2z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 59.9,
    className: "st4pkh",
    width: 24,
    height: 2.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 44.6,
    className: "st4pkh",
    width: 24,
    height: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5pkh",
    d: "M7.3,18.8c7,0,14,0,21.1,0c-0.6-3.9-1.2-7.8-1.8-11.6c-6.3,0-12.7,0-19-0.1C7.5,11,7.4,14.9,7.3,18.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5pkh",
    d: "M5.6,30.7c0.3-1.5,0.6-3.1,1-4.6c7.6,0,15.1,0,22.7,0.1c0.2,1.8,0.5,3.6,0.7,5.4C21.8,31.3,13.7,31,5.6,30.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0pkh",
    d: "M31.9,44.6c-9.4,0-18.7,0-28.1-0.1c0.7-4.8,1.4-9.5,2.2-14.3c8.3,0,16.6,0,25,0C31.2,35.1,31.5,39.8,31.9,44.6z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0pkh",
    d: "M30.2,27.5c-8.1,0-16.3,0-24.4,0c0.5-2.9,0.9-5.9,1.4-8.8c7.1,0,14.1,0.1,21.2,0.1 C28.9,21.7,29.5,24.6,30.2,27.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9pkh",
    d: "M24,8.1c-0.2,0-0.4,0-0.7,0c1,12.2,2,24.4,3,36.6c0.7,0,1.3,0,2,0C27,32.5,25.7,20.2,24.4,8 C24.2,8,24.1,8.1,24,8.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9pkh",
    d: "M11.9,44.5c0.6-12.1,1.3-24.1,1.9-36.2c-0.3,0-0.6,0-0.9,0c-0.9,11.1-1.8,22.2-2.7,33.3c0.4,1,0.7,2.1,1.1,3.1 C11.5,44.6,11.7,44.5,11.9,44.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10pkh",
    points: "17.6,8.3 20.3,8.3 21,40.6 18.5,40.6 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11pkh",
    d: "M20.8,44.8h-2.2c0-1.4,0-2.9,0-4.3c0.8,0,1.6,0,2.5,0C20.9,42,20.8,43.4,20.8,44.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10pkh",
    d: "M11,8.3c0.7,0,1.4,0,2.2,0c-0.8,11-1.7,22-2.5,32.9c-0.7,0-1.3,0-2,0C9.5,30.2,10.2,19.3,11,8.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9pkh",
    d: "M7.7,8.6c0.4,0,0.8,0,1.2,0C7.6,20.5,6.3,32.4,5,44.4c-0.7-1.3-1.5-2.6-2.2-3.9C4.5,29.8,6.1,19.2,7.7,8.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11pkh",
    d: "M11.3,44.6c-0.8,0-1.5,0-2.3,0c-0.1-1.1-0.3-2.3-0.4-3.4c0.7,0,1.3,0,2,0C10.9,42.4,11.1,43.5,11.3,44.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11pkh",
    d: "M5.6,44.6c-0.6,0-1.2,0-1.9,0C3.2,43.4,2.6,42.2,2,41c0.5,0,1.1,0,1.6,0C4.3,42.1,4.9,43.4,5.6,44.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10pkh",
    d: "M32,44.7c0.4-1.2,0.9-2.4,1.3-3.7C31.5,30,29.7,18.9,27.9,7.9c-0.4,0-0.9,0-1.3,0C28.4,20.1,30.2,32.4,32,44.7 z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10pkh",
    d: "M6.9,8.5c0.3,0,0.6,0,1,0C6.5,19.3,5.1,30.1,3.6,40.9c-0.5,0-1.1,0-1.6,0C3.6,30.2,5.3,19.3,6.9,8.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st10pkh",
    d: "M24.1,8.2c0.6,0,1.1,0,1.7,0C27,19.1,28.2,30.1,29.4,41c-0.6-0.1-1.1-0.1-1.7-0.2 C26.6,29.9,25.3,19.1,24.1,8.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11pkh",
    d: "M26.4,44.7c0.8,0,1.6,0,2.4,0c0.2-1.2,0.4-2.5,0.6-3.7c-0.6-0.1-1.1-0.1-1.7-0.2 C27.3,42.1,26.8,43.4,26.4,44.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st9pkh",
    d: "M31,44.6c-1.5-12.2-3.1-24.4-4.6-36.5c0.4,0,0.7,0,1.1,0c1.5,12.2,3,24.4,4.5,36.6C31.7,44.7,31.3,44.6,31,44.6 z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0pkh",
    d: "M6.9,8.8C6.8,8.5,6.6,7.3,7.2,6.2C7.5,5.8,7.7,5.6,8,5.4c2.7-0.2,5.5-0.4,8.5-0.4c4,0,7.8,0.2,11.2,0.5 c0.1,1.1,0.2,2.1,0.3,3.2C21,8.7,14,8.8,6.9,8.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0pkh",
    d: "M8,4.1C7.5,3.6,7.5,3.1,7.5,3.1c0,0-0.1-0.9,1-1.9c1.9-1.8,16.8-1,17.7-1C27.5,0.8,28.2,2,28,3 c0,0.2-0.2,0.7-0.7,1.1C24.6,4.3,9.2,5.6,8,4.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4pkh",
    d: "M27.7,4c-2.9-0.4-5.9-0.6-9.1-0.7c-3.8,0-7.4,0.2-10.8,0.7c0,0.5,0,1,0,1.6c3.3-0.4,6.8-0.7,10.6-0.7 c3.3,0,6.4,0.3,9.3,0.7C27.7,5.1,27.7,4.6,27.7,4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st12pkh",
    d: "M5.1,151.7c0.5-0.5,1-0.9,1.5-1.4c-0.6-1.5-1.2-2.9-1.8-4.4c3.1,1,7.6,2.1,13,2.1c5.6,0,10.1-1.1,13.3-2.1 c-0.7,1.3-1.4,2.7-2.1,4c0.7,0.5,1.3,0.9,2,1.4c-2.8,1.2-7.7,2.9-14,2.8C11.9,154.1,7.7,152.8,5.1,151.7z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 162.5,
    className: "st0pkh",
    width: 27,
    height: 12.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0pkh",
    d: "M4.8,157.2c-0.7,1-2.4,3.5-1.6,5c0.3,0.6,0.9,0.8,1.2,0.8c3.2,1,23.4,0.4,26.3,0.3c0.3-0.1,1.4-0.6,1.9-1.8 c0.6-1.4,0-3.3-1.6-4.4c-3.7,1-8.8,1.9-14.9,1.7C11.6,158.7,7.8,158,4.8,157.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0pkh",
    d: "M4.8,158.6c0-2.4,0-4.8,0-7.2c3.1,1,7.8,2.2,13.6,2.2c5.3-0.1,9.6-1.1,12.6-2.2c0,2.4,0,4.9,0,7.3 c-3.8,0.6-8.4,1.1-13.6,1.1C12.6,159.7,8.4,159.2,4.8,158.6z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 149.7,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 181.2054 145.2694)",
    className: "st13pkh",
    width: 0.5,
    height: 27
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 143.8,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 174.7755 138.9652)",
    className: "st13pkh",
    width: 0.5,
    height: 26.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPloKoonHilt);
export default __webpack_public_path__ + "static/media/plo-koon-hilt.4a5e6362.svg";
export { ForwardRef as ReactComponent };